<script setup lang="ts">
import ImageCheckbox from "@/stories/form/ImageCheckbox/ImageCheckbox.vue";
import SimpleLoader from "@/stories/displays/SimpleLoader/SimpleLoader.vue";
import { onBeforeUnmount, onMounted, ref } from "vue";
import usePixabayDialog from "@/stories/dialogs/imageDialogs/pixabay/usePixabayDialog";
import type { SharedImageListProps } from "@/types";

defineProps<SharedImageListProps>();

const dialog = usePixabayDialog();

const loadMoreTrigger = ref<HTMLElement | null>(null);
let observer: IntersectionObserver | null = null;

onMounted(() => {
  observer = new IntersectionObserver(
    async (entries: IntersectionObserverEntry[]) => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        await dialog.loadNextPage();
      }
    },
  );

  if (loadMoreTrigger.value) {
    observer.observe(loadMoreTrigger.value);
  }
});

onBeforeUnmount(() => {
  observer?.disconnect();
});
</script>

<template>
  <div class="flex flex-col gap-4 space-between relative">
    <div
      class="grid grid-cols-2 gap-4 desktop:mt-0 desktop:grid-cols-4 min-h-[27.125rem] max-h-[30rem]"
    >
      <ImageCheckbox
        v-for="image of dialog.images.value"
        lazyLoading
        lazyLoadingSelector="pixabay-dialog-content"
        :disabled="!isSelecteableMore"
        :key="image.id"
        :src="image.url || image.base64 || ''"
        :alt="image.name"
        :checked="dialog.selectedImages.value.includes(image.id || '')"
        @toggle="() => dialog.toggleImages(image)"
      />
      <div ref="loadMoreTrigger" class="col-span-full h-1">
        <SimpleLoader v-if="dialog.loading.value" />
      </div>
    </div>
  </div>
</template>
